import React from 'react';
import { Container, Row } from 'shards-react';

import PageTitle from '../../../components/PageTitle';
import Errors from '../../../components/Errors';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import { Provider as LoadingProvider } from '../../../contexts/LoadingContext';
import AccountNameOrIdInput from '../../../components/inputs/AccountNameOrIdInput';
import UserEmailInput from '../../../components/inputs/UserEmailInput';
import Constants from '../../../data/Constants';
import { useAccounts } from '../../../hooks/queries/useAccounts';
import { useUrlState } from '../../../hooks/useUrlState';
import { positiveIntegerParam, stringParam } from '../../../utils/urlStateParams';
import Table from './Table';
import ActionBar from '../../../components/common/ActionBar';

const inputs = [AccountNameOrIdInput, UserEmailInput];
const actions = [{ route: '/admin/accounts/new', label: 'Crear nueva cuenta' }];

const URL_STATE_CONFIG = {
  accountNameOrId: stringParam(),
  userEmail: stringParam(),
  page: positiveIntegerParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const filter = {
    accountNameOrId: urlState.accountNameOrId || undefined,
    userEmail: urlState.userEmail || undefined
  };
  const { accounts, loading, error } = useAccounts(filter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      accountNameOrId: newFilter.accountNameOrId?.trim() || '',
      userEmail: newFilter.userEmail?.trim() || '',
      page: 1
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Cuentas" />
      </Row>
      <LoadingProvider value={loading}>
        <GenericSearchBar handleSubmit={onSubmit} inputs={inputs} values={urlState} />
        <ActionBar items={actions} />
        <Errors errors={error ? ['No se pudieron cargar las cuentas.'] : null} />
        <Table
          accounts={accounts}
          disableNext={accounts.length < Constants.elementsPerPage}
          disablePrev={urlState.page === 1}
          onPageClick={handlePageClick}
        />
      </LoadingProvider>
    </Container>
  );
};

export default List;
